module.exports = __webpack_public_path__ + "static/media/solution-2-sec2.066b5794.png";